<div class="exclusion-calendar" data-element="exclusion-calendar">

  <!-- Months flow left-to-right in ONE horizontal-scroll row (never stacked). A single month
       is centered; multiple months left-align so the overflow stays scrollable. -->
  <div class="cal-months-row" [class.single]="this.months.length === 1" *ngIf="this.months.length > 0">
    <div class="cal-month" *ngFor="let month of this.months">
      <p class="month-label" data-element="calendar-month-label">{{ month.label }}</p>
      <div class="cal">
        <span class="dow" *ngFor="let h of this.dowHeaders">{{ h }}</span>
        <ng-container *ngFor="let week of month.weeks">
          <ng-container *ngFor="let cell of week">
            <span *ngIf="cell.date === null" class="cal-blank"></span>
            <span *ngIf="cell.date !== null"
                  class="cal-day"
                  [attr.data-element]="this.dataElementFor(cell)"
                  [ngClass]="this.classFor(cell)"
                  (click)="this.onDayClick(cell)">{{ cell.num }}</span>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <p class="note empty" *ngIf="this.months.length === 0">
    Pick a Start And End Date First — the Calendar Shades the Chosen Range.
  </p>

  <div class="cal-actions">
    <dx-button text="Apply" type="default" data-element="btn-calendar-apply"
               [width]="96" (onClick)="this.onApply()"></dx-button>
    <dx-button text="Cancel" data-element="btn-calendar-cancel"
               [width]="96" (onClick)="this.onCancel()"></dx-button>
    <dx-button text="Reset" data-element="btn-calendar-reset"
               [width]="96" [disabled]="this.draft.length === 0"
               (onClick)="this.onReset()"></dx-button>
  </div>
</div>
